/**
 * @author Auto
 * @date 2026/01/26
 * @Description: takeAreaAddress -- 提货区域地址管理
 */
<template>
  <div class="takeAreaAddress" @keyup.enter="enterSearch">
    <el-form
      class="table-search-bar maintain-form"
      inline
      ref="areaAddressForm"
      :model="areaAddressForm"
      label-width="96px">
      <el-form-item label="提货区域名称" prop="takeAreaName">
        <el-select v-model="areaAddressForm.takeAreaName" placeholder="请选择提货区域" clearable filterable>
          <el-option
            v-for="item in takeAreaOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省市区" prop="region">
        <el-cascader
          :options="regionOptions"
          v-model="areaAddressForm.region"
          :props="cascaderProps"
          clearable
          placeholder="请选择省市区">
        </el-cascader>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="areaAddressForm.status" placeholder="请选择">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="areaAddressData"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="takeAreaName"
        label="提货区域名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="proviceName"
        label="省"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="cityName"
        label="市"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="areaName"
        label="区"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="address"
        label="详细地址"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="status"
        :formatter="statusFormatter"
        label="状态"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <add-or-edit-dialog
      :show.sync="addOrEditDialogShow"
      :info="editInfo"
      :take-area-options="takeAreaOptions"
      :region-options="regionOptions"
      @save="handleSave">
    </add-or-edit-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AddOrEditDialog from './addOrEditDialog'

export default {
  name: 'takeAreaAddress',
  components: { AddOrEditDialog },
  data () {
    return {
      areaAddressForm: {
        takeAreaName: '',
        region: [],
        status: ''
      },
      regionOptions: this.$storage.getItem(this.$storage.keys.REGION_JSON) || [],
      takeAreaOptions: [],
      addOrEditDialogShow: false,
      editInfo: {},
      cascaderProps: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      statusArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 0,
          label: '生效中'
        },
        {
          value: 1,
          label: '已失效'
        }
      ]
    }
  },
  methods: {
    ...mapActions(['getAreaAddressList', 'getArea', 'addAreaAddress', 'updateAreaAddress', 'deleteAreaAddress']),
    // 初始化提货区域选项
    initTakeAreaOptions () {
      this.getArea({ areaType: 2 }).then(res => {
        this.takeAreaOptions = res.map(item => {
          return { id: item.id, name: item.areaName }
        })
      })
    },
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      // 将级联选择的值转换为省名、市名、区名
      let proviceName = ''
      let cityName = ''
      let areaName = ''

      if (this.areaAddressForm.region && this.areaAddressForm.region.length > 0) {
        const regionCodes = this.areaAddressForm.region
        // 从regionOptions中查找对应的名称
        for (let i = 0; i < this.regionOptions.length; i++) {
          const province = this.regionOptions[i]
          if (province.code === regionCodes[0]) {
            proviceName = province.name
            if (regionCodes.length > 1 && province.children) {
              for (let j = 0; j < province.children.length; j++) {
                const city = province.children[j]
                if (city.code === regionCodes[1]) {
                  cityName = city.name
                  if (regionCodes.length > 2 && city.children) {
                    for (let k = 0; k < city.children.length; k++) {
                      const area = city.children[k]
                      if (area.code === regionCodes[2]) {
                        areaName = area.name
                        break
                      }
                    }
                  }
                  break
                }
              }
            }
            break
          }
        }
      }

      const params = {
        takeAreaName: this.areaAddressForm.takeAreaName,
        proviceName: proviceName,
        cityName: cityName,
        areaName: areaName,
        status: this.areaAddressForm.status,
        pageNo: 1
      }
      this.getAreaAddressList(params)
    },
    reset () {
      this.$refs['areaAddressForm'].resetFields()
      this.handleSearch()
    },
    statusFormatter (row) {
      switch (row.status) {
        case 0:
          return '生效中'
        case 1:
          return '已失效'
        default:
          return '-'
      }
    },
    handleSizeChange (val) {
      this.getAreaAddressList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getAreaAddressList({ pageNo: val })
    },
    // 新增
    add () {
      this.editInfo = {}
      this.addOrEditDialogShow = true
    },
    // 编辑
    handleEdit (index, row) {
      this.editInfo = { ...row }
      this.addOrEditDialogShow = true
    },
    // 保存
    handleSave (formData) {
      const isEdit = !!formData.id
      const action = isEdit ? this.updateAreaAddress : this.addAreaAddress
      action(formData).then(() => {
        this.$message.success(isEdit ? '编辑成功' : '新增成功')
        this.addOrEditDialogShow = false
        this.handleSearch()
      })
    },
    // 删除
    handleDelete (index, row) {
      this.$confirm('是否确认删除该提货区域地址？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteAreaAddress({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.handleSearch()
        })
      }).catch(() => {})
    }
  },
  computed: {
    ...mapState({
      areaAddressData: state => state.areaAddress.list,
      listState: state => state.areaAddress.listState
    })
  },
  mounted () {
    this.initTakeAreaOptions()
    this.handleSearch()
  }
}
</script>

<style scoped>
</style>
